<template>
	<main id="home" class="page">
		<HighlightCardRow v-if="layoutType === 'row'" />
		<div v-for="(item, index) in selectedCampaignArray" :key="index">
			<CampaignSectionRow
				v-if="layoutType === 'row'"
				:header="item.category"
				:subheader="item.description"
				:content="item.items"
				:allowFooter="selectedCampaignArray.length - 1 === index"
				:className="item.category.replace(/\s+/g, '-').toLowerCase()"
			/>

			<CampaignSectionGrid
				v-else
				:header="item.category"
				:subheader="item.description"
				:content="item.items"
				:className="item.category.replace(/\s+/g, '-').toLowerCase()"
			/>
		</div>
	</main>
</template>

<script>
import CampaignSectionRow from '@/components/cards/CampaignSectionRow.vue';
import CampaignSectionGrid from '@/components/cards/CampaignSectionGrid.vue';
import HighlightCardRow from '@/components/cards/HighlightCardRow.vue';
import CampaignService from '@/services/toolbox/campaign-service';

export default {
	name: 'CampaignEditorHome',
	components: {
		CampaignSectionRow,
		CampaignSectionGrid,
		HighlightCardRow,
	},
	data() {
		return {
			selectedCampaignArray: [],
			CampaignArray: [],
			layoutType: 'row',
		};
	},
	created() {
		const app = this;

		this.selectedCampaignArray = this.CampaignArray;

		this.filterCampaign(this.$route.matched[1].meta.category);

		CampaignService.getMenu().then((response) => {
			this.CampaignArray = response.data;
			app.filterCampaign(app.$route.matched[1].meta.category);
		});
	},
	watch: {
		$route(to) {
			this.filterCampaign(to.meta.category);
		},
	},
	methods: {
		filterCampaign(category) {
			if (category) {
				this.selectedCampaignArray = this.CampaignArray.filter(
					(el) => el.category === category,
				);
				this.layoutType = 'grid';
			} else {
				this.selectedCampaignArray = this.CampaignArray;
				this.layoutType = 'row';
			}
		},
	},
};
</script>

<style scoped lang="scss">
.view {
	margin-top: $header-height;
	background-color: $off-white;
}

.home {
	background-color: $off-white;
	display: flex;
	height: calc(100vh - #{$top-nav-height});
	position: relative;
}

.temp {
	position: absolute;
	left: 30%;
	right: 30%;
	width: 40%;
	bottom: 0;
}

.bb-nested-view {
	width: $brand-builder-sub-view-with;
	position: fixed;
	top: $top-nav-height + 1px;
	background-color: $white;
	border-left: 1px solid $border-color-light;
	border-right: 1px solid $border-color-light;
	height: calc(100vh - (#{$top-nav-height} + (#{$base-gap} * 2 + 6px)));
	z-index: 100;
	padding: $base-gap;
	-ms-overflow-style: none;
	overflow: -moz-scrollbars-none;
	scrollbar-width: none;
	@include lg {
		overflow-x: visible;
	}
	overflow-y: auto;

	&::-webkit-scrollbar {
		width: 0 !important;
	}
	@include sm {
		top: $top-nav-height + 1px;
		height: calc(
			100vh -
				(
					#{$top-nav-height} + 1px + #{$brand-builder-tool-height} +
						(#{$base-gap} * 2)
				)
		); //211px
		left: 0;
	}

	@include mobile {
		width: calc(100vw - 30px);
		left: 0;
		height: calc(
			100vh -
				(
					#{$top-nav-height} + 1px + #{$brand-builder-tool-height} +
						(#{$base-gap-mobile} * 2)
				)
		);
		padding: $base-gap-mobile;
	}
}
</style>
